import React from 'react'

export const ModalConfirm = ({ onClose, onAcept, title, description, discardDescription = "Descartar cambios", acceptDescription = "Guardar cambios" }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[35vw] h-[20vh] relative">
        <div className="bg-black text-white flex justify-between items-center px-4 py-2 rounded-t-lg">
          <h2 className="text-lg font-bold">{title}</h2>
        </div>
        <div className="p-4">
          <div className="h-96 overflow-y-auto text-center">
            <span className='font-bold'>
              {description}
            </span>
            <div className='h-auto flex flex-row justify-center gap-4  mt-5'>
              <div
                onClick={() => onClose()}
                className='h-10 min-w-20 px-2 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533] ml-4'
              >
                {discardDescription}
              </div>
              <div
                onClick={() => onAcept()}
                className='h-10 px-2 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]'
              >
                {acceptDescription}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
